import { render, staticRenderFns } from "./ReleaseTable.vue?vue&type=template&id=6d269e0a&scoped=true"
import script from "./ReleaseTable.vue?vue&type=script&lang=ts"
export * from "./ReleaseTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d269e0a",
  null
  
)

export default component.exports